<template>
  <div id="app">
    <div id="window-container" class="window-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {agency_plan_fixed_list} from './addon/fixed_list'

export default {
  name: 'atosa_web',

  data() {
    return {
      inactive: false,
      interval1: null,
      interval2: null
    }
  },

  async beforeMount() {
    // todo: set lang
    if (!localStorage.getItem('lang')) {
      // check if is in Vietnam timezone
      if (new Date().getTimezoneOffset() === -7 * 60) {
        this.$i18n.locale = 'vi'
      } else {
        this.$i18n.locale = 'en'
      }
      localStorage.setItem('lang', this.$i18n.locale)
    }

    this.$store.state.ads_error = false

    await this.m__on_send_ping('f5')

    this.interval1 = setInterval(() => {
      if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
        this.m__on_send_ping('')
      }
    }, 30000)

    this.m__on_inactive(15000, () => {
      this.inactive = true
    })

    document.addEventListener('wheel', function () {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur()
      }
    })

    try {
      await this.m__fix_system_proxy()
      await this.m__get_current_pack()
      await this.m__get_advanced_ads_list()

      this.interval2 = setInterval(async () => {
        if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
          await this.m__get_current_pack()
          await this.m__get_advanced_ads_list()
        }
      }, 60000 * 5)
    } catch (e) {
      console.error(e)
    }

    this.EB.$on('get_advanced_ads_list', () => {
      this.m__get_advanced_ads_list()
    })
  },

  beforeDestroy() {
    clearInterval(this.interval1)
    clearInterval(this.interval2)
    this.EB.$off('get_advanced_ads_list')
  },

  methods: {
    async m__fix_system_proxy() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
        const resp = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())
        for (const shop of resp.body.data) {
          const system_proxy = await this.m__init_system_proxy(shop.shop_id, shop.username)
          if (shop.extra_data && (!shop.extra_data.system_proxy || shop.extra_data.system_proxy !== system_proxy)) {
            await this.UPDATE_SELLER_EXTRA_DATA(shop._id, {
              ...shop.extra_data,
              system_proxy,
              user_agent: navigator.userAgent
            })
          }
        }

        this.$store.state.shop = resp.body.data
      }
    },

    async m__init_system_proxy(shop_id, username) {
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/init_system_proxy', {
          shop_id,
          username
        }, this.cf())
        return response.body.system_proxy
      } catch (e) {
        console.error(`error init_system_proxy: ${e}`)
        return ''
      }
    },

    m__on_inactive(ms, cb) {
      let wait = setTimeout(cb, ms)

      document.onmousemove = document.mousedown = document.mouseup = document.onkeydown = document.onkeyup = document.focus = () => {
        this.inactive = false

        clearTimeout(wait)
        wait = setTimeout(cb, ms)
      }
    },

    async m__on_send_ping(context = '') {
      if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
        const json = {
          host: window.location.host,
          path: this.$route.path,
          time: dayjs().unix(),
          context: context,
          inactive: this.inactive,
          device: 'web'
        }

        try {
          const data = this.encrypt_data(json)
          await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/ping', {data}, this.cf())
        } catch (e) {
        }
      }
    },

    async m__get_advanced_ads_list() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
        try {
          const advanced_resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/get_advanced_ads_list', this.cf())
          if (advanced_resp && advanced_resp.body && advanced_resp.body.data) {
            this.$store.state.advanced_ads_list = [...advanced_resp.body.data]
          }

          const vit_resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/get_vit_ads_list', this.cf())
          if (vit_resp && vit_resp.body && vit_resp.body.data) {
            this.$store.state.vit_ads_list = [...vit_resp.body.data]
          }

          const plan_resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/get_agency_plan_list', this.cf())
          if (plan_resp && plan_resp.body && plan_resp.body.data) {
          }
          this.$store.state.agency_plan_list = [...agency_plan_fixed_list, ...plan_resp.body.data]
        } catch (e) {
        }
      }
    },

    async m__get_current_pack() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.token) {
        const resp = await this.$http.get(this.API.store_get_current_package, this.cf())
        await this.$store.dispatch('set__package', resp.body.data)
        localStorage.setItem('pack', JSON.stringify(resp.body.data))
      }
    },

    async UPDATE_SELLER_EXTRA_DATA(_id, extra_data) {
      return await this.$http.put(this.API.shopee_manager__add_shop.replace('/shop-manager/shop', `/shop-manager/${_id}/`), {
        extra_data: {...extra_data}
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.$store.state.userInfo.token
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "sass/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue